import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useCallback, useEffect, useState } from 'react';
import PostByAgg from '../utils/axios';
import ModalAlert from './ModalAlert';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';
import { useAuth } from '../context/AuthContext';
import Select from "react-select";


const ViewProfileLayer = () => {
    const [imagePreview, setImagePreview] = useState('assets/images/user-grid/user-grid-img13.png');
    const { updateProfileImage } = useProfile();
    const [file, setFile] = useState(null);
    const {email,setEmail} = useAuth()
    const [labelType, setLabelType] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [country, setCountry] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [province, setProvince] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState(null);
    const [city, setCity] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [labelTypeCode, setLabelTypeCode] = useState('');
    const [musicLabelCode, setMusicLabelCode] = useState('');
    const [modal, setModal] = useState(<div></div>);
    const [bankAccount,setBankAccount] = useState ("")
    const [bankList, setBankList] = useState([]) 
    const [selectedBank, setSelectedBank] = useState(null)
    const [bankAccountName,setBankAccountName] = useState("")
    const Navigate = useNavigate();

    // Fungsi untuk membaca gambar yang diupload
    // const readURL = (input) => {
    //     if (input.target.files && input.target.files[0]) {
    //         const reader = new FileReader();
    //         reader.onload = (e) => {
    //             setImagePreview(e.target.result); // Menampilkan preview gambar
    //             upda(e.target.result); // Update gambar di context
    //         };
    //         reader.readAsDataURL(input.target.files[0]);
    //     }
    // };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0]; // Ambil file pertama
        if (!selectedFile) return;  // Jika tidak ada file, keluar dari fungsi
    
        setFile(selectedFile);  // Menyimpan file di state
    
        const reader = new FileReader();
        reader.onload = (e) => {
            setImagePreview(e.target.result);  // Menampilkan preview gambar
            // updateProfileImage(e.target.result);  // Update gambar di context
        };
        reader.readAsDataURL(selectedFile);  // Membaca file sebagai URL gambar
    };

    const UpdateProfile = () => {
        const url = 'label/lm/v1/music-label/find-by-email';
        PostByAgg({
            url: url,
            body: {
                'email': email
            },
            onResponse: (response) => {
                console.log("ResponseviewProfile: ", response.data);
                if (response.data.code === '2002000') {
                    const data = response.data.data;
                    setEmail(response.data.data.email);
                    setLabelType(response.data.data.label_type_name);
                    setName(response.data.data.music_label_name);
                    setPhone(response.data.data.telephone);
                    setAddress(response.data.data.address);
                    setSelectedCountry(response.data.data.country_code);
                    setSelectedProvince(response.data.data.province_code);
                    setSelectedCity(response.data.data.city_code);
                    setLabelTypeCode(response.data.data.label_type_code);
                    setMusicLabelCode(response.data.data.music_label_code);
                    const bankFromApi = data.bank_code || data.bank_name;
                    setSelectedBank(bankFromApi); 
                    setBankAccount(response.data.data.bank_account_no)
                    setBankAccountName(response.data.data.bank_account_name)
                    // setPhoto(response.data.data.photo)
                    if (response.data.data.photo) {
                        setImagePreview(`data:image/png;base64,${response.data.data.photo}`);
                        updateProfileImage(`data:image/png;base64,${response.data.data.photo}`);
                    }
                } else {
                    alert("Error: " + response.data.message);
                }
            },
            onError: (error) => {
                console.log("Error: ", error);
                if(error.response.status === 400 || error.response.status === 404){
                    setModal(
                    <ModalAlert
                        show={true}
                        type={'failed'}
                        text={error.message}
                        action={()=>{}}
                    />
                  )
                }
            }
        })
    }

    const GetCountry = useCallback(() => {
            PostByAgg({
                url: 'location/v1/country/find-by-country-name',
                body: {
                    'page': 1,
                    'page_size': 200,
                },
                onResponse:onResponseCountry,
                onError:onErrorCountry
            })
        },[]);
        
        function  onResponseCountry(response) {
            console.log("Response Country: ", response.data.data)
            if (Array.isArray(response.data.data)) {
                setCountry(response.data.data);  // Set the data correctly
            } else {
                console.error("Expected an array of countries, but got:", response.data.data);
                setCountry([]);  // If data is not in the expected format, set an empty array
            }
        }
        
        function  onErrorCountry(error) {
            if(error.response){
                setModal(
                    <ModalAlert
                        show={true}
                        type={'failed'}
                        text={error.message}
                        action={()=>{}}
                    />
                )
            }
        }

        const GetProvince = useCallback((countryCode) =>{
                PostByAgg({
                    url: 'location/v1/province/find-by-country-code',
                    body: {
                        'page': 1,
                        'page_size': 200,
                        'country_code':countryCode
                    },
                    onResponse:onResponseProvince,
                    onError:onErrorProvince
                })
            },[]);

            const GetCity = useCallback((provinceCode) => {
                    PostByAgg({
                        url: 'location/v1/city/find-by-province-code',
                        body: {
                            'page': 1,
                            'page_size': 200,
                            'province_code':provinceCode
                        },
                        onResponse:onResponseCity,
                        onError:onErrorCity
                    })
                },[]);
            
                function  onResponseCity(response) {
                    console.log("Response City: ", response.data.data)
                    if (Array.isArray(response.data.data)) {
                        setCity(response.data.data)
                    }else{
                        setCity([])
                    }
                }

                function  onErrorCity(error) {
                    console.log("Error City: ", error)
                    if(error.response){
                        setModal(
                            <ModalAlert
                                show={true}
                                type={'failed'}
                                text={error.message}
                                action={()=>{}}
                            />
                        )
                    }
                }
        
            function  onResponseProvince(response) {
                console.log("Response Province: ", response.data); // Debugging
                if (Array.isArray(response.data.data)) {
                    setProvince(response.data.data)
                }
            }
        
            function  onErrorProvince(error) {
                console.log("Error Province: ", error)
                if(error.response.status === 400 || error.response.status === 404){
                    setModal(
                        <ModalAlert
                            show={true}
                            type={"failed"}
                            text={error.message}
                            action={() => {}}
                        />
                    )
                }
            }
    

        const handleCountryChange = (e) => {
            const countryCode = e.target.value;
            console.log("Selected Country Code:", countryCode);  // Debugging
            setSelectedCountry(countryCode);// Update selected country code
            setSelectedProvince(null);  // Reset province
            setSelectedCity(null); 
            GetProvince(countryCode); // Fetch provinces based on the selected country
        };

        const handleProvinceChange = (e) => {
            const provinceCode = e.target.value;
            console.log("Selected Province Code:", provinceCode);  // Debugging
            setSelectedProvince(provinceCode);// Update selected province code
            setSelectedCity(null);
            GetCity(provinceCode); // Fetch cities based on the selected province
        };

        const handleCityChange = (e) => {
            const cityCode = e.target.value;
            console.log("Selected City Code:", cityCode);  // Debugging
            setSelectedCity(cityCode);// Update selected city code
        }

        const GetBank = () => {
            const url = 'label/lm/v1/bank/find-by-name'
            PostByAgg({
                url,
                body: {
                    "bank_name": ""
                },
                onResponse: onResponseBank,
                onError: onErrorBank
            })
        }

        const onResponseBank = (response) => {
            console.log("ini response bank list di profile",response.data.data)
            if (Array.isArray(response.data.data)) {
                setBankList(response.data.data)
            }else{
                setBankList([])
            }
        }

        const onErrorBank = (err) => {
            console.log("iini error response bank di profile", err)
            if(err.response.status === 404 || err.response.status === 400){
                setModal(
                    <ModalAlert
                        show={true}
                        type={"failed"}
                        text={err.message}
                        action={()=>{}}
                        />
                )
            }
        }

        //  const handleBankChange = (e) => {
        //     const bank= e.target.value;
        //     console.log("Selected Bank Code:", bank); 
        //     setSelectedBank(bank);
        // }

    //     const GetBank = () => {
    //     const url = 'label/lm/v1/bank/find-by-name';
    //     PostByAgg({
    //         url,
    //         body: { bank_name: "" }, // load semua bank
    //         onResponse: (res) => {
    //             setBankList(Array.isArray(res.data.data) ? res.data.data : [])
    //         },
    //         onError: (err) => console.log("Error Bank:", err)
    //     })
    // }

    useEffect(() => {
    if (bankList.length > 0 && selectedBank) {
        const foundBank = bankList.find(
        b => b.bank_code === selectedBank || b.bank_name === selectedBank
        );
        if (foundBank) {
        setSelectedBank(foundBank.bank_code); // paksa ke bank_code
        }
    }
    }, [bankList]);

    useEffect(() => {
        UpdateProfile();
        GetBank()
        
    }, []);

    useEffect(() => {
        GetCountry();
        if (selectedCountry) {
            GetProvince(selectedCountry);
        }
        if (selectedProvince) {
            GetCity(selectedProvince);
        }

    }, [GetCountry, GetProvince, GetCity, selectedCountry, selectedProvince]);

    const handleSave = () => {  
        console.log("DOri: ", email, labelType, name, phone, address);

    
        // Jika ada file, masukkan file tersebut ke dalam FormData
        const formData = new FormData();

        // Jika ada file, tambahkan file ke FormData
        if (file) {
            formData.append("file", file); // pastikan `file` adalah state yang menyimpan file yang diupload
        }
    
        console.log("name", name);
        // Menambahkan data profil lainnya ke FormData
        const profileData = {
            music_label_code: musicLabelCode,
            music_label_name: name,
            email: email,
            telephone: phone,
            address: address,
            label_type_code: labelTypeCode,
            city_code: selectedCity,
            updated_by: "admin",
            bank_code: selectedBank ,
            bank_account_no: bankAccount,
            bank_account_name: bankAccountName
        };


    
        // Menambahkan data JSON ke FormData sebagai string
        formData.append("data", JSON.stringify(profileData));
    
        // Kirimkan data ke API untuk update profile dengan FormData
        PostByAgg({
            url: 'label/lm/v1/music-label/update',
            body: formData, // kirimkan formData
            headers: { 
                'Content-Type': 'multipart/form-data'  // pastikan Content-Type untuk upload file
            },
            onResponse:onResponseSave,
            onError:onErrorSave
        });

        function onResponseSave(response) {
            console.log("Response Save: ", response.data);
            if (response.data.code === '2002000') {
                setModal(
                    <ModalAlert
                        show={true}
                        type={"success"}
                        text={response.data.message.id}
                        action={() => {
                            if (file) {
                                updateProfileImage(imagePreview);
                            }
                            setModal(<div></div>); // Close the modal
                        }}
                        />
                )
            } else {
                alert("Error: " + response.data.message.id);
                setModal(
                    <ModalAlert
                        show={true}
                        type={"failed"}
                        text={response.data.message.id}
                        action={() => {
                            Navigate('/view-profile');
                            setModal(<div></div>);
                        }}
                        />
                );
            }
        }

        function onErrorSave(error) {
            setModal(
                <ModalAlert
                    show={true}
                    type={"failed"}
                    text={error.response.data.message.id}
                    action={() => {
                        Navigate('/view-profile');
                        setModal(<div></div>);
                    }}
                    />
            )
        }
    }

    const handleCancel = () => {
        Navigate('/dashboard')
        setFile(null);  // Reset file input
        // setImagePreview(photo);  // Mengembalikan ke foto sebelumnya
    }

    return (
        <>
            <div className="row gy-4">
                <div className="col-lg-4">
                    <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
                        <div className="pb-24 ms-16 mb-24 me-16 mt-100">
                            <div className="text-center p-24 mt-24 border border-top-1 border-start-1 border-end-1">
                                <img
                                    src={imagePreview}
                                    alt=""
                                    className="border br-white border-2 w-200-px h-200-px rounded-circle object-fit-cover"
                                />
                                <h6 className="mb-0 mt-16">{name}</h6>
                                    <span className="text-secondary-light mb-16">{email}</span>
                            </div>
                            <div className="mt-24">
                                <h6 className="text-xl mb-16">Personal Info</h6>
                                <ul>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            {" "}Label Type :
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {labelType}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            {" "}
                                            Email :
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {email}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            {" "}
                                            Phone :
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {phone}
                                        </span>
                                    </li>
                                    {/* <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            {" "}
                                            Department
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            : Design
                                        </span>
                                    </li> */}
                                    {/* <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            {" "}
                                            Designation
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            : UI UX Designer
                                        </span>
                                    </li> */}
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            {" "}Bank Name:
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {bankList.find(bank => bank.bank_code === selectedBank)?.bank_name || "No Bank Selected"}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            {" "}
                                            Bank Account Name:
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {bankAccountName}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1 mb-12">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            {" "}
                                            No Account Bank:
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {bankAccount}
                                        </span>
                                    </li>
                                    <li className="d-flex align-items-center gap-1">
                                        <span className="w-30 text-md fw-semibold text-primary-light">
                                            {" "}
                                            Address :
                                        </span>
                                        <span className="w-70 text-secondary-light fw-medium">
                                            {address}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-8 justify-content-center align-items-center">
                    <div className="card h-100">
                        <div className="card-body p-24">
                            <ul
                                className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                                id="pills-tab"
                                role="tablist"
                            >
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link d-flex align-items-center px-24 active"
                                        id="pills-edit-profile-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-edit-profile"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-edit-profile"
                                        aria-selected="true"
                                    >
                                        Edit Profile
                                    </button>
                                </li>
                                {/* <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link d-flex align-items-center px-24 active"
                                        id="pills-change-passwork-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-change-passwork"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-change-passwork"
                                        aria-selected="true"
                                        // tabIndex={-1}
                                    >
                                        Change Password
                                    </button>
                                </li> */}
                                {/* <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link d-flex align-items-center px-24"
                                        id="pills-notification-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-notification"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-notification"
                                        aria-selected="false"
                                        tabIndex={-1}
                                    >
                                        Notification Settings
                                    </button>
                                </li> */}
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div
                                    className="tab-pane fade show active"
                                    id="pills-edit-profile"
                                    role="tabpanel"
                                    aria-labelledby="pills-edit-profile-tab"
                                    tabIndex={0}
                                >
                                    <h6 className="text-md text-primary-light mb-16">Profile Image</h6>
                                    {/* Upload Image Start */}
                                    <div className="mb-24 mt-16">
                                        <div className="avatar-upload">
                                            <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                                                <input
                                                    type="file"
                                                    id="imageUpload"
                                                    accept=".png, .jpg, .jpeg"
                                                    hidden
                                                    onChange={handleFileChange}
                                                />
                                                <label
                                                    htmlFor="imageUpload"
                                                    className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                                                >
                                                    <Icon icon="solar:camera-outline" className="icon"></Icon>
                                                </label>
                                            </div>
                                            <div className="avatar-preview">
                                                <div
                                                    id="imagePreview"
                                                    style={{
                                                        backgroundImage: `url(${imagePreview})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* Upload Image End */}
                                    <form action="#">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="name"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        Name
                                                        <span className="text-danger-600">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control radius-8"
                                                        id="name"
                                                        placeholder="Enter Full Name"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                   />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="email"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        Email <span className="text-danger-600">*</span>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control radius-8"
                                                        id="email"
                                                        placeholder="Enter email address"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="phone"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        Phone
                                                    </label>
                                                    <input
                                                        type="phone"
                                                        className="form-control radius-8"
                                                        id="phone"
                                                        placeholder="Enter phone number"
                                                        value={phone}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="labelType"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        Label Type
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control radius-8"
                                                        id="labelType"
                                                        placeholder="Enter Label Type"
                                                        value={labelType}
                                                        disabled
                                                        onChange={(e) => setLabelType(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="depart"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        Country
                                                        <span className="text-danger-600">*</span>{" "}
                                                    </label>
                                                    <select className='form-select text-black px-40 bg-neutral-50 justify-content-center radius-10'
                                                onChange={handleCountryChange}
                                                value={selectedCountry || ''}
                                                disabled={true}
                                                >
                                            <option value="">Select Country</option>
                                            {
                                                    country.length > 0 ? (
                                                        country.map((item, index) => (
                                                            <option key={index} value={item.country_code}>{item.country_name}</option>
                                                        ))
                                                    ) : (
                                                        <option>No options available</option>
                                                    )
                                                }
                                                
                                            </select>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="desig"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        Province
                                                        <span className="text-danger-600">*</span>{" "}
                                                    </label>
                                                    <select className='form-select bg-neutral-50 justify-content-center h-56 px-40 radius-10'
                                                    onChange={handleProvinceChange}
                                                    value={selectedProvince || ''}
                                                    disabled={!selectedCountry}
                                                    >
                                                <option value="">Select Province</option>
                                                {
                                                        province.length > 0 ? (
                                                            province.map((item, index) => (
                                                                <option key={index} value={item.province_code}>{item.province_name}</option>
                                                            ))
                                                        ) : (
                                                            <option>No options available</option>
                                                        )
                                                    }
                                                </select>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="Language"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        City
                                                        <span className="text-danger-600">*</span>{" "}
                                                    </label>
                                                    <select className='form-select h-56 px-40 bg-neutral-50 justify-content-center radius-10'
                                                    onChange={handleCityChange}
                                                    value={selectedCity || ''}
                                                    disabled={!selectedProvince}
                                                    >
                                                        <option value="">Select City</option>
                                                    {
                                                            city.length > 0 ? (
                                                                city.map((item, index) => (
                                                                    <option key={index} value={item.city_code}>{item.city_name}</option>
                                                                ))
                                                            ) : (
                                                                <option>No options available</option>
                                                            )
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            {/* <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                    Cari Bank <span className="text-danger-600">*</span>
                                                    </label>
                                                    <div className="d-flex gap-2">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ketik nama bank (misal: BCA)"
                                                        value={bankName}
                                                        onChange={(e) => setBankName(e.target.value)}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={GetBank}
                                                    >
                                                        Cari
                                                    </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="Language"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        Bank Code
                                                        <span className="text-danger-600">*</span>{" "}
                                                    </label>
                                                    <select className='form-select h-56 px-40 bg-neutral-50 justify-content-center radius-10'
                                                    onChange={handleBankChange}
                                                    value={selectedBank || ''}
                                                    >
                                                        <option value="">Select Bank</option>
                                                    {
                                                            bankList.length > 0 ? (
                                                                bankList.map((item, index) => (
                                                                    <option key={index} value={item.bank_code}>{item.bank_name}</option>
                                                                ))
                                                            ) : (
                                                                <option>No options available</option>
                                                            )
                                                        }
                                                    </select>
                                                </div>
                                            </div> */}

                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                                                    Bank <span className="text-danger-600">*</span>
                                                    </label>
                                                    <Select
                                                        options={bankList.map((item) => ({
                                                            value: item.bank_code,
                                                            label: item.bank_name,
                                                        }))}
                                                        value={
                                                            bankList
                                                            .map((item) => ({ value: item.bank_code, label: item.bank_name }))
                                                            .find((opt) => opt.value === selectedBank) || null
                                                        }
                                                        onChange={(opt) => setSelectedBank(opt?.value || "")}
                                                        placeholder="Pilih Bank"
                                                        isClearable
                                                        />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="name"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        No Account Bank
                                                        <span className="text-danger-600">*</span>
                                                    </label>
                                                    <input
                                                        type=""
                                                        className="form-control radius-8"
                                                        id="bank_account"
                                                        placeholder="Enter Account Number"
                                                        value={bankAccount}
                                                        onChange={(e) => setBankAccount(e.target.value)}
                                                   />
                                                </div>
                                            </div>
                                             <div className="col-sm-6">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="name"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        Name Account Bank
                                                        <span className="text-danger-600">*</span>
                                                    </label>
                                                    <input
                                                        type=""
                                                        className="form-control radius-8"
                                                        id="bank_account_name"
                                                        placeholder="Enter Account Number"
                                                        value={bankAccountName}
                                                        onChange={(e) => setBankAccountName(e.target.value)}
                                                   />
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <div className="mb-20">
                                                    <label
                                                        htmlFor="desc"
                                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                    >
                                                        Address
                                                    </label>
                                                    <textarea
                                                        name="#0"
                                                        rows={6}
                                                        className="form-control radius-8"
                                                        id="desc"
                                                        placeholder="Input Address"
                                                        value={address}
                                                        onChange={(e) => setAddress(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center gap-3">
                                            <button
                                                type="button"
                                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                                                onClick={handleSave}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                {/* <div className="tab-pane fade show active" id="pills-change-passwork" role="tabpanel" aria-labelledby="pills-change-passwork-tab" tabIndex="0">
                                  <form onSubmit={handleSave}>
                                    <div className="mb-20">
                                        <label htmlFor="your-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            Existing Password <span className="text-danger-600">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type={existingPasswordVisible ? "text" : "password"}
                                                className="form-control radius-8"
                                                id="existing-password"
                                                placeholder="Enter New Password*"
                                                value={existingPassword}
                                               onChange={(e) => {
                                                   setExistingPassword(e.target.value);
                                                   setError('');
                                                   setSuccessMessage('');
                                               }}
                                            />
                                            <span
                                                className={`toggle-password ${!existingPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                                onClick={toggleExistingPasswordVisibility}
                                            ></span>
                                        </div>
                                    </div>
                                    <div className="mb-20">
                                        <label htmlFor="your-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            New Password <span className="text-danger-600">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type={passwordVisible ? "text" : "password"}
                                                className="form-control radius-8"
                                                id="your-password"
                                                placeholder="Enter New Password*"
                                                value={password}
                                                onChange={(e) => {
                                                    setPassword(e.target.value);
                                                    setError('');
                                                    setSuccessMessage('');
                                                  }}
                                            />
                                            <span
                                                className={`toggle-password ${!passwordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                                onClick={togglePasswordVisibility}
                                            ></span>
                                        </div>
                                    </div>
                                    <div className="mb-20">
                                        <label htmlFor="confirm-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            Confirm Password <span className="text-danger-600">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type={confirmPasswordVisible ? "text" : "password"}
                                                className="form-control radius-8"
                                                id="confirm-password"
                                                placeholder="Confirm Password*"
                                                value={confirmPassword}
                                                onChange={(e) => {
                                                    setConfirmPassword(e.target.value);
                                                    setError('');
                                                    setSuccessMessage('');
                                                }}
                                            />
                                            <span
                                                className={`toggle-password ${!confirmPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                                onClick={toggleConfirmPasswordVisibility}
                                            ></span>
                                        </div>
                                    </div>
                                  
                        {error && <div className="alert alert-danger">{error}</div>}
                        {successMessage && <div className="alert alert-success">{successMessage}</div>}

                            <button
                                className="btn btn-primary w-42 rounded-lg hover-bg-primary py-12 px-32"
                                type="submit"
                                
                            >
                                Save
                            </button>
                                  </form>
                                </div>
                                <div
                                    className="tab-pane fade"
                                    id="pills-notification"
                                    role="tabpanel"
                                    aria-labelledby="pills-notification-tab"
                                    tabIndex={0}
                                >
                                    <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                                        <label
                                            htmlFor="companzNew"
                                            className="position-absolute w-100 h-100 start-0 top-0"
                                        />
                                        <div className="d-flex align-items-center gap-3 justify-content-between">
                                            <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                                                Company News
                                            </span>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="companzNew"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                                        <label
                                            htmlFor="pushNotifcation"
                                            className="position-absolute w-100 h-100 start-0 top-0"
                                        />
                                        <div className="d-flex align-items-center gap-3 justify-content-between">
                                            <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                                                Push Notification
                                            </span>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="pushNotifcation"
                                                defaultChecked=""
                                            />
                                        </div>
                                    </div>
                                    <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                                        <label
                                            htmlFor="weeklyLetters"
                                            className="position-absolute w-100 h-100 start-0 top-0"
                                        />
                                        <div className="d-flex align-items-center gap-3 justify-content-between">
                                            <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                                                Weekly News Letters
                                            </span>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="weeklyLetters"
                                                defaultChecked=""
                                            />
                                        </div>
                                    </div>
                                    <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                                        <label
                                            htmlFor="meetUp"
                                            className="position-absolute w-100 h-100 start-0 top-0"
                                        />
                                        <div className="d-flex align-items-center gap-3 justify-content-between">
                                            <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                                                Meetups Near you
                                            </span>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="meetUp"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-switch switch-primary py-12 px-16 border radius-8 position-relative mb-16">
                                        <label
                                            htmlFor="orderNotification"
                                            className="position-absolute w-100 h-100 start-0 top-0"
                                        />
                                        <div className="d-flex align-items-center gap-3 justify-content-between">
                                            <span className="form-check-label line-height-1 fw-medium text-secondary-light">
                                                Orders Notifications
                                            </span>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="orderNotification"
                                                defaultChecked=""
                                            />
                                        </div>
                                    </div>
                                </div> */}
                             
                            </div>

                        </div>
                    </div>
                </div>
                {modal}
            </div>
        </>

    );
};

export default ViewProfileLayer;